// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Networks.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  ArchiveNetworkRequest,
  ArchiveNetworkResponse,
  CreateNetworkRequest,
  CreateNetworkResponse,
  GetNetworksRequest,
  GetNetworksResponse,
  UpdateNetworkRequest,
  UpdateNetworkResponse,
} from "./Models/NetworkModels";

export const protobufPackage = "daisi.protos.v1";

export type NetworksProtoDefinition = typeof NetworksProtoDefinition;
export const NetworksProtoDefinition = {
  name: "NetworksProto",
  fullName: "daisi.protos.v1.NetworksProto",
  methods: {
    get: {
      name: "Get",
      requestType: GetNetworksRequest,
      requestStream: false,
      responseType: GetNetworksResponse,
      responseStream: false,
      options: {},
    },
    update: {
      name: "Update",
      requestType: UpdateNetworkRequest,
      requestStream: false,
      responseType: UpdateNetworkResponse,
      responseStream: false,
      options: {},
    },
    archive: {
      name: "Archive",
      requestType: ArchiveNetworkRequest,
      requestStream: false,
      responseType: ArchiveNetworkResponse,
      responseStream: false,
      options: {},
    },
    create: {
      name: "Create",
      requestType: CreateNetworkRequest,
      requestStream: false,
      responseType: CreateNetworkResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface NetworksProtoServiceImplementation<CallContextExt = {}> {
  get(request: GetNetworksRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetNetworksResponse>>;
  update(
    request: UpdateNetworkRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateNetworkResponse>>;
  archive(
    request: ArchiveNetworkRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ArchiveNetworkResponse>>;
  create(
    request: CreateNetworkRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateNetworkResponse>>;
}

export interface NetworksProtoClient<CallOptionsExt = {}> {
  get(request: DeepPartial<GetNetworksRequest>, options?: CallOptions & CallOptionsExt): Promise<GetNetworksResponse>;
  update(
    request: DeepPartial<UpdateNetworkRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateNetworkResponse>;
  archive(
    request: DeepPartial<ArchiveNetworkRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ArchiveNetworkResponse>;
  create(
    request: DeepPartial<CreateNetworkRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateNetworkResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
